import React, { useContext, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { MoreVert, Add } from '@mui/icons-material';
import { SeasonShowContext } from '../../Providers/SeasonShowProvider';
import AddSeasonDialog from './AddSeasonDialog';
import DeleteSeasonDialog from './DeleteSeasonDialog';
import EditSeasonDialog from './EditSeasonDialog';

export default function Index() {
    const { selectedShow, selectedSeason } = useContext(SeasonShowContext);

    const [addOpen, setAddOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpen = (dispatch: React.Dispatch<React.SetStateAction<boolean>>) => () => {
        handleClose();
        dispatch(true);
    }

    return (
        <>
            <IconButton sx={{ mh: 40 }} onClick={(e) => selectedSeason ? handleClick(e) : setAddOpen(true)}>
                {selectedSeason && <MoreVert />}
                {!selectedSeason && <Add />}
            </IconButton>
            {selectedSeason && (
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem disabled={!selectedShow} onClick={handleOpen(setAddOpen)}>Add</MenuItem>
                    <MenuItem disabled={!selectedSeason} onClick={handleOpen(setEditOpen)}>Edit</MenuItem>
                    <MenuItem disabled={!selectedSeason} onClick={handleOpen(setDeleteOpen)}>Delete</MenuItem>
                </Menu>
            )}
            <AddSeasonDialog open={addOpen} onClose={() => setAddOpen(false)} />
            <EditSeasonDialog open={editOpen} onClose={() => setEditOpen(false)} />
            <DeleteSeasonDialog open={deleteOpen} onClose={() => setDeleteOpen(false)} />
        </>
    )
}